import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import withPortalId from '../../../modules/portal/withPortalId'
import { removeImage } from '../../../modules/portal-remote/portalImageService'

const withRemoveImage = getOptions => WrappedComponent => {
  return compose(withPortalId, connect(null, { removeImage }))(
    class RemoveImageWrapper extends React.Component {
      handleRemoveImage = async () => {
        const { imageId, onRemoveItem } = getOptions(this.props)
        const { portalId } = this.props
        try {
          if (imageId) {
            let result = await removeImage(portalId, imageId)
            if (!result) {
              throw Error('cannot delete image from remote')
            }
          }
          if (onRemoveItem) onRemoveItem()
        } catch (error) {
          console.log(error.message)
        }
      }

      render() {
        return (
          <WrappedComponent
            {...this.props}
            onRemoveImage={this.handleRemoveImage}
          />
        )
      }
    },
  )
}

export default withRemoveImage



// WEBPACK FOOTER //
// ./src/components/templates/image-edit/withRemoveImage.js